const FEATUREFLAG_HOMEPAGE_ACCESS = 'FEATUREFLAG_HOMEPAGE_ACCESS'

export { FEATUREFLAG_HOMEPAGE_ACCESS }
